import React, { useEffect } from 'react';
import { useTimer } from '@/contexts/TimerContext';

interface PomodoroTimerProps {
  selectedTask?: {
    title: string;
  } | null;
}

export const PomodoroTimer: React.FC<PomodoroTimerProps> = ({ selectedTask }) => {
  const timer = useTimer();

  useEffect(() => {
    // Default title from index.html
    let title = 'PomoMax - Maximize Your Productivity';
    
    if (timer.state.timeRemaining > 0) {
      // Format the time as MM:SS
      const minutes = Math.floor(timer.state.timeRemaining / 60);
      const seconds = Math.floor(timer.state.timeRemaining % 60);
      const timeString = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      
      if (timer.state.phase === 'work') {
        const taskTitle = selectedTask?.title || 'Pomodoro';
        title = `${timeString} - ${taskTitle}`;
      } else if (timer.state.phase === 'shortBreak') {
        title = `${timeString} - Short Break`;
      } else if (timer.state.phase === 'longBreak') {
        title = `${timeString} - Long Break`;
      }
    }
    
    document.title = title;

    return () => {
      document.title = 'PomoMax - Maximize Your Productivity';
    };
  }, [timer.state.timeRemaining, timer.state.phase, selectedTask]);

  return null;
}; 